import { STANDALONE_ROUTE_REGISTRY } from 'constants/routes';

const STANDALONE_PUBLIC_ROUTE_PREFIXES = Object.values(STANDALONE_ROUTE_REGISTRY).map(({ basePath }) => basePath);

const isStandalonePublicRoute = (pathname: string): boolean =>
  STANDALONE_PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export default isStandalonePublicRoute;
